import { useSidebarStore } from '@/stores/sidebar-store';
import { useTranslation } from '@kgc/i18n';
import { useLocation, useNavigate } from 'react-router-dom';
import { BOTTOM_NAV_TABS } from './nav-config';

/**
 * BottomNav — Mobil PWA 5 tab-os navigáció
 * Wizard route-okon nem renderelődik (AppLayout kezeli)
 * @see tech-spec-nav-ux-overhaul.md F3-T5
 */
export function BottomNav() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { openDrawer } = useSidebarStore();

  const isTabActive = (href: string | undefined) => {
    if (!href) return false;
    if (href === '/dashboard') return pathname === href;
    return pathname.startsWith(href);
  };

  return (
    <nav
      className="flex items-stretch border-t border-gray-200 dark:border-white/10 bg-white dark:bg-[#1a4f5c]"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 8px)' }}
      aria-label={t('nav.navigation')}
    >
      {BOTTOM_NAV_TABS.map(tab => {
        const active = isTabActive(tab.href);

        return (
          <button
            key={tab.id}
            onClick={() => {
              if (tab.action === 'openDrawer') {
                openDrawer();
              } else if (tab.href) {
                navigate(tab.href);
              }
            }}
            className="flex flex-1 flex-col items-center justify-center gap-0.5 py-2 transition-colors"
            style={active ? { color: '#14b8a6' } : { color: '#64748b' }}
            aria-label={t(tab.label)}
          >
            {/* Badge ikon */}
            <div
              className="nav-icon-badge"
              style={{
                backgroundColor: active ? tab.iconColor : `${tab.iconColor}33`, // 20% opacity inaktív
              }}
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="#fff"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d={tab.icon} />
              </svg>
            </div>

            {/* Label */}
            <span
              className="text-[10px] leading-tight"
              style={active ? { fontWeight: 700, color: '#14b8a6' } : { color: '#64748b' }}
            >
              {t(tab.label)}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
